import React from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

const fieldClassName =
  "w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition";

const ClientApproversFields = ({
  approvers = [],
  onApproverChange,
  onAddApprover,
  onRemoveApprover,
}) => {
  return (
    <section className="rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
            ผู้มีอำนาจลงนามเอกสาร
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            รายชื่อผู้ติดต่อที่สามารถรับอีเมลและลงนามใบเสนอราคาผ่านระบบ e-sign ได้
          </p>
        </div>
        <button
          type="button"
          onClick={onAddApprover}
          className="inline-flex items-center gap-2 rounded-md bg-indigo-500 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-600 transition"
        >
          <FaPlus size={12} />
          Add
        </button>
      </div>

      {approvers.length === 0 ? (
        <p className="rounded-md border border-dashed border-gray-300 dark:border-gray-700 px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
          ยังไม่ได้เพิ่มผู้มีอำนาจลงนาม
        </p>
      ) : (
        <div className="space-y-3">
          {approvers.map((approver, index) => (
            <div
              key={approver._id || index}
              className="grid grid-cols-1 gap-3 rounded-md bg-gray-50 dark:bg-gray-900/60 p-3 sm:grid-cols-[1fr_1fr_1fr_auto]"
            >
              <div>
                <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
                  Name
                </label>
                <input
                  type="text"
                  value={approver.name || ""}
                  onChange={(event) =>
                    onApproverChange(index, "name", event.target.value)
                  }
                  placeholder="Somchai"
                  className={fieldClassName}
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
                  Email
                </label>
                <input
                  type="email"
                  value={approver.email || ""}
                  onChange={(event) =>
                    onApproverChange(index, "email", event.target.value)
                  }
                  placeholder="somchai@example.com"
                  className={fieldClassName}
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
                  Position
                </label>
                <input
                  type="text"
                  value={approver.position || ""}
                  onChange={(event) =>
                    onApproverChange(index, "position", event.target.value)
                  }
                  placeholder="Managing Director"
                  className={fieldClassName}
                />
              </div>

              <div className="flex items-end">
                <button
                  type="button"
                  onClick={() => onRemoveApprover(index)}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-red-500 text-white hover:bg-red-600 transition"
                  title="Remove approver"
                >
                  <FaTrash size={13} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default ClientApproversFields;
